import { SESSION_MANAGER_HOST } from '@/constants';
import httpClient from '@/modules/cart/services/api/client';
const { VITE_CUSTOMER_EMAIL, VITE_CUSTOMER_PASSWORD } = import.meta.env;

export const customerSignIn = async () => {
  const data = await httpClient.post(`${SESSION_MANAGER_HOST}/sign-in`, {
    email: VITE_CUSTOMER_EMAIL,
    password: VITE_CUSTOMER_PASSWORD
  });

  if (typeof window !== 'undefined') {
    const userdata = {
      email: VITE_CUSTOMER_EMAIL,
      firstName: 'Tester',
      lastName: 'Tester'
    };
    window.localStorage.setItem('sessionData', JSON.stringify(userdata));
  }
  return data;
};
